import { showNotification } from "@mantine/notifications";

const defaultErrorMessage = "不明なエラーが発生しました。しばらくしてからもう一度お試しください。";

export function showError(message: string = defaultErrorMessage) {
  showNotification({
    title: "Error",
    message,
    color: "red",
    withCloseButton: true,
    autoClose: 8000, // 8 seconds
  });
}

export function showSuccess(message: string) {
  showNotification({
    title: "Success",
    message,
    color: "teal",
    withCloseButton: true,
    autoClose: 8000, // 8 seconds
  });
}
